// Generated by ts-to-zod
import { z } from 'zod';
import { userSchema } from '../models/user.schema';

export const patchUserPayloadSchema = userSchema.partial();
